import React from 'react';
import './TechnicalDocuments.css';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const TechnicalDocuments = () => {
  /* Dil fonksiyonlarını çekiyoruz kanka */
  const { t, lang } = useLanguage();

  const documents = [
    {
      title: lang === 'TR' 
        ? "DRYCOW PREMIX Teknik Föy" 
        : lang === 'AR' 
        ? "نشرة فنية لبريمكس دراي كاو (DRYCOW PREMIX)" 
        : "DRYCOW PREMIX Technical Sheet",
      desc: lang === 'TR' 
        ? "Kuru dönem büyükbaşlarda 100–150 g / baş / gün." 
        : lang === 'AR' 
        ? "لماشية فترة الجفاف: 100-150 جم / رأس / يوم." 
        : "100–150 g / head / day for dry period cattle.",
      pdfName: "drycow-premix-kuru-donem-premiksi-teknik-foy.pdf"
    },
    {
      title: lang === 'TR' 
        ? "FRESHCALVE PREMIX Teknik Föy" 
        : lang === 'AR' 
        ? "نشرة فنية لبريمكس فريش كالف (FRESHCALVE PREMIX)" 
        : "FRESHCALVE PREMIX Technical Sheet",
      desc: lang === 'TR' 
        ? "Doğum sonrası 100–200 g / baş / gün destek." 
        : lang === 'AR' 
        ? "دعم ما بعد الولادة: 100-200 جم / رأس / يوم." 
        : "100–200 g / head / day support after birth.",
      pdfName: "freshcalve-premix-dogum-sonrasi-premiksi-teknik-foy.pdf"
    },
    {
      title: lang === 'TR' 
        ? "VITACALF ELECTROLYTE Teknik Föy" 
        : lang === 'AR' 
        ? "نشرة فنية لإلكتروليت فيتاكالف (VITACALF ELECTROLYTE)" 
        : "VITACALF ELECTROLYTE Technical Sheet",
      desc: lang === 'TR' 
        ? "100 g ürün / 2 litre ılık su ile karıştırılır." 
        : lang === 'AR' 
        ? "يخلط 100 جم من المنتج مع 2 لتر من الماء الدافئ." 
        : "Mix 100 g product with 2 liters of warm water.",
      pdfName: "vitacalf-electrolyte-buzagi-elektroliti-teknik-foy.pdf"
    }
  ];

  return (
    /* Navbar'dan gelen yönlendirmenin burayı bulması için ID sabit kaldı kanka */
    <section id="teknik-foyler" className="tech-doc-section">
      <div className="tech-doc-container">
        <div className="tech-doc-header">
          <span className="tech-doc-badge">{t('technical.badge')}</span>
          <h2>{t('technical.title')}</h2>
          <p>{t('technical.desc')}</p>
        </div>

        <div className="tech-doc-grid">
          {documents.map((doc, index) => (
            <div key={index} className="tech-doc-card">
              <h3>{doc.title}</h3>
              <p className="doc-instruction">{doc.desc}</p>
              <div className="pdf-info-box">
                <strong>PDF:</strong> {doc.pdfName}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnicalDocuments;